import {

    CREATE_WAREHOUSE_LOADING,
    LOADING_ALL_WAREHOUSE,
    ERROR_ALL_WAREHOUSE,
    GET_ALL_WAREHOUSE,
    LOADING_DELETE_WAREHOUSE,
    DELETE_WAREHOUSE,
    ERROR_ONLY_ONE_WAREHOUSE,
    GET_ONLY_ONE_WAREHOUSE,
    LOADING_UPDATE_WAREHOUSE,
    UPDATE_WAREHOUSE,
    ERROR_UPDATE_WAREHOUSE,
    LOADING_ONLY_ONE_WAREHOUSE

} from '../../admin/actions/types'

const initialWareHouseState = {
    isLoadingView: false,
    isLoadingWareHouse: false,
    wareHouseList: [],
    isLoadingDeleteWareHouse: false,
    isLoadingUpdateWareHouse: false,
    isErrorUpdateWareHouse: false,
    isErrorGetOnlyWarehouse: false,
    isloadingGetOnlyWinery: false

}
export default function (state = initialWareHouseState, action) {
    switch (action.type) {
        case CREATE_WAREHOUSE_LOADING:
            return { ...state, isLoadingView: true }
        case LOADING_ALL_WAREHOUSE:
            return { ...state, isLoadingWareHouse: true }
        case ERROR_ALL_WAREHOUSE:
            return { ...state, isLoadingWareHouse: false }
        case GET_ALL_WAREHOUSE:
            return { ...state, isLoadingWareHouse: false, wareHouseList: action.payload }
        case LOADING_DELETE_WAREHOUSE:
            return { ...state, isLoadingDeleteWareHouse: true }
        case DELETE_WAREHOUSE:
            const newwareHouseList = state.wareHouseList.filter((item) => item['_id'] !== action.payload.id)
            return { ...state, isLoadingDeleteWareHouse: false, wareHouseList: newwareHouseList }
        case LOADING_ONLY_ONE_WAREHOUSE:
            return { ...state, isloadingGetOnlyWinery:true }
        case GET_ONLY_ONE_WAREHOUSE:
            return { ...state, wareHouse: action.payload.data }
        case ERROR_ONLY_ONE_WAREHOUSE:
            return { ...state, isErrorGetOnlyWarehouse: true }
        case UPDATE_WAREHOUSE:
            return { ...state, isLoadingUpdateWareHouse: false, wareHouse: action.payload.data }
        case LOADING_UPDATE_WAREHOUSE:
            return { ...state, isLoadingUpdateWareHouse: true }
        case ERROR_UPDATE_WAREHOUSE:
            return { ...state, isLoadingUpdateWareHouse: false }
        default:
            return state;
    }
}